import { mainApiAxios as axios } from '@/plugins/axios'

export default {
    // history: prior turns oldest first, excluding the message being sent,
    // each { role: 'user'|'assistant', content: '...' }
    // concise: true (default) asks for a short answer; false gets the full detailed answer
    sendMessage(message, history, language, concise = true) {
        return axios.post('ai-chat/message', { message, history, language, concise })
    }
}
